// extracted by mini-css-extract-plugin
export var container = "_93-0";
export var icon = "_93-1";
export var text = "_93-2";